import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../ParticipantsStore';
import ModalStore from '../../../../../Modal/Store';
import Form from './Form';
import Modal from '../../../../../Modal';

interface Props {
  store: ParticipantsStore;
  modalStore: ModalStore;
}
const AddUserGroupMemberships: React.FC<Props> = ({ modalStore, store }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={''}
          modalWidth="overflow-y-auto w-2/5"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <Form store={store} modalStore={modalStore} />
        </Modal>
      );
  }
};

export default observer(AddUserGroupMemberships);
